import { useQuery } from 'react-query';
import CardRelatorio from '../CardRelatorio';
import Valor from '../Valor';
import axios from 'axios';
import Skeleton from '../../../components/layout/Skeleton';
import { translateFilterFinanceiro } from './util';

type Props = {
  titulo: string;
  fact: 'total_entradas' | 'total_saidas' | 'saldo';
  dataInicio: string;
  dataFim: string;
  cor?: string;
};

const CardTotalFinanceiro = ({ titulo, fact, dataInicio, dataFim, cor }: Props) => {
  const q = useQuery(
    ['financeiroTotal', fact, dataInicio, dataFim],
    async () => {
      const qs = new URLSearchParams();
      qs.append('facts', fact);
      qs.append('filter', translateFilterFinanceiro(dataInicio, dataFim));

      const res = await axios.get(
        '/api/relatorios/lancamento_financeiro?' + qs.toString(),
      );
      return res.data.result?.[0]?.[fact] ? +res.data.result[0][fact] : 0;
    },
    { refetchOnWindowFocus: false },
  );

  return (
    <CardRelatorio titulo={titulo} style={{ height: '105px' }}>
      {q.isFetching ? (
        <Skeleton format="box" />
      ) : (
        <Valor
          valor={q.data ?? 0}
          prepend="R$"
          digits={2}
          color={cor}
          valueSize="1.8rem"
          fractionSize="1.1rem"
        />
      )}
    </CardRelatorio>
  );
};

export default CardTotalFinanceiro;
